import { defineMessages } from 'react-intl';

export default defineMessages({
  searchSymbolLibrary: {
    id: 'cboard.components.SymbolSearch.searchSymbolLibrary',
    defaultMessage: 'Search symbol library'
  },
  clearText: {
    id: 'cboard.components.SymbolSearch.clearText',
    defaultMessage: 'Clear text'
  },
  uploadAnImage: {
    id: 'cboard.components.InputImage.uploadImage',
    defaultMessage: 'Upload an image'
  }
});
